import { Field } from 'redux-form';
import RangeInput from './RangeInput';

const NumberRange = (props) => {
  const { id, name, type, typeName, order, options, required } = props;
  return (
    <div>
      <Field
        id={id}
        name={name}
        typeName={typeName}
        order={order}
        options={options}
        required={required}
        component={RangeInput}
      />
    </div>
  );
}

export default NumberRange;